import { memo } from "react";
import { Grid, Icon, Input, Popup } from "semantic-ui-react";
import { HandleInputChange } from "../../../../../custom-hooks/form/types";

type DNSProps = {
  onChange: HandleInputChange;
  ipVersion: number;
  dnsNameservers: string;
};

const DNS = ({ onChange, dnsNameservers, ipVersion }: DNSProps) => {
  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <h5>
          DNS name servers
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Format example :
            {ipVersion === 4
              ? "8.8.8.8, 8.8.8.4"
              : "2001:4860:4860::8888, 2001:4860:4860::8844"}
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <Input
          value={dnsNameservers}
          className="select-box full"
          name="dnsNameservers"
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};

export default memo(DNS);
